import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { AuthStore, useAuthStore } from '@/stores/auth-store';
import router from '@/router';
import { useRoute } from 'vue-router';
import { useToast } from '@/composables/useToast';
import { i18n } from '@/plugins/i18n';
import { LoginForm } from '@/interfaces/auth/auth-store.interface';

export const useAuth = () => {
  const authStore: AuthStore = useAuthStore();

  const { showToast } = useToast();
  const { user, fullName, initialsName, hasProfile, photo, joinDate } = storeToRefs(authStore);
  const route = useRoute();

  const loading = ref(false);
  const loginSuccess = ref(false);

  const handleAuthLogin = async (form: LoginForm) => {
    try {
      loading.value = true;
      const response = await authStore.authLogin(form);

      const { success, error } = response;

      if (success) {
        loginSuccess.value = true;
        await showToast(i18n.global.t('login.successMessage') as string);
        return response;
      } else {
        await showToast(error as string);
      }
    } catch (error: unknown) {
      loginSuccess.value = false;
      await showToast(error instanceof Error ? error.message : 'Unknown error', 'error');
    } finally {
      loading.value = false;
    }
  };

  const goTo = async (newRoute: string) => {
    await router.push({ name: newRoute, query: { rentalId: route.query.rentalId as string } });
  };

  return {
    loading,
    loginSuccess,
    user,
    fullName,
    initialsName,
    hasProfile,
    photo,
    joinDate,
    changeEmail: authStore.changeEmail,
    changePhoto: authStore.changePhoto,
    handleAuthLogin,
    goTo,
  };
};
